export const ID = '7cdd4eb3-d6d6-44c8-bd62-4cd8ac5d982d';

export const NAME = 'StorageMart Storage Calculator';
